import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import SEO from "@/components/SEO";

const NotFound = () => {
  return (
    <div data-testid="page-not-found" className="pt-[72px] min-h-screen flex items-center">
      <SEO
        title="Page not found — SPIRUVA"
        description="The requested page could not be found. Return to the SPIRUVA homepage to explore the phycocyanin grade portfolio, resources and pre-launch program."
        robots="noindex,follow"
      />
      <div className="container-wide py-32 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <p className="eyebrow mb-5">◦  Error 404 · Page not found</p>
          <h1 className="font-display text-6xl md:text-8xl text-brand-black tracking-tight leading-[0.95]">
            This <span className="italic text-brand-teal">pond's empty.</span>
          </h1>
          <p className="text-brand-black/70 mt-6 max-w-lg leading-relaxed">
            The page you're looking for has been deprecated, moved, or never cultivated. Let's get you back to a productive route.
          </p>
          <Link to="/" data-testid="not-found-home-cta" className="btn-primary mt-8">
            <Home size={14} /> Back to Home
          </Link>
        </div>
        <div className="md:col-span-5">
          <div className="aspect-square w-full bg-gradient-to-br from-brand-green via-brand-teal to-brand-gold relative overflow-hidden">
            <div className="absolute inset-0 grain opacity-40 mix-blend-overlay" />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="font-display text-[160px] text-brand-cream/90">404</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
